import { Expose } from 'class-transformer';

export class AddMultipleVehiclesResponse {
  added: string[];
  @Expose({ name: 'not_added' })
  notAdded: string[];
}
